import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Back",
	updateManyExternalIntegrations: {
		success: "Integrations updated successfully",
	},
	externalStoreIntegrationStatus: {
		synced: "Synced",
		pendingSyncing: "Syncing pending",
		pendingImporting: "Importing pending",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
